const arrayze = (a: any) => (Array.isArray(a) ? a : [a])

const naiveIsArrayOfStrs = (a: any) => (Array.isArray(a) ? (a.length > 0 ? typeof a[0] === "string" : false) : false)

const naiveIsObj = (a: any) => typeof a === "object" && a !== null && !Array.isArray(a)

export const transformErrorForForm = (error: any, skipTransform: boolean | string[] = false) => {
  if (error.response?.status === 400) {
    let errorData
    if (naiveIsObj(error?.data)) {
      errorData = error.data as Record<string, any>
    }

    const makeErrors = (errorObj: Record<string, any>): Record<string, any> => {
      return Object.keys(errorObj).reduce((transformed, key) => {
        const rawError = errorObj[key]
        let error
        if (
          skipTransform !== false &&
          (skipTransform === true || (Array.isArray(skipTransform) && skipTransform.includes(key)))
        ) {
          return {
            ...transformed,
            [key]: rawError,
          }
        }
        if (naiveIsObj(rawError)) {
          error = makeErrors(rawError)
        } else if (naiveIsArrayOfStrs(rawError)) {
          error = arrayze(errorObj[key]).join(" ")
        } else if (Array.isArray(rawError)) {
          error = rawError.map((err) => makeErrors(err))
        } else {
          error = arrayze(errorObj[key]).join(" ")
        }
        return {
          ...transformed,
          [key]: error,
        }
      }, {})
    }

    if (errorData) {
      return makeErrors(errorData)
    }
  }
  // When no 400 (not related 2 form)
  // add a special __noFieldsServerError key \w original error
  return {
    __noFieldsServerError: error,
  }
}

export function data2formdata(data: any) {
  const fd = new FormData()
  if (data instanceof File) {
    fd.append("", data)
  } else if (Array.isArray(data)) {
    for (let i = 0; i < data.length; i++) {
      const itemFD = data2formdata(data[i])
      for (const [key, value] of itemFD.entries()) {
        fd.append(key ? `[${i}]${key}` : ``, value)
      }
    }
  } else if (typeof data === "object" && data !== null) {
    for (const [outerKey, value] of Object.entries(data)) {
      const itemFD = data2formdata(value)
      for (const [key, value] of itemFD.entries()) {
        if (key === "") {
          fd.append(`${outerKey}`, value)
        } else if (key[0] === "[") {
          fd.append(`${outerKey}${key}`, value)
        } else {
          fd.append(`${outerKey}.${key}`, value)
        }
      }
    }
  } else {
    fd.append("", data?.toString() ?? "")
  }
  return fd
}